import { Auth } from '@aws-amplify/auth';

const cookieStorage = {
  domain:
    process.env.NODE_ENV === 'development' ? 'localhost' : 'listwithclever.com',
  secure: true,
  path: '/',
  expires: 365, // expires in days
  sameSite: 'none',
};

Auth.configure({
  region: process.env.AWS_AMPLIFY_REGION,
  userPoolId: process.env.AWS_AMPLIFY_USER_POOL_ID,
  userPoolWebClientId: process.env.AWS_AMPLIFY_USER_POOL_WEB_CLIENT_ID,
  mandatorySignIn: true,
  authenticationFlowType: 'USER_PASSWORD_AUTH',
  cookieStorage,
  // Endpoint override is only honoured outside production. The browser sends
  // plaintext passwords via USER_PASSWORD_AUTH, so allowing this env var to
  // take effect in a production build would silently redirect every login to a
  // non-AWS host. The guard makes the intent (local cognito-local only)
  // enforceable in code.
  ...(process.env.NODE_ENV !== 'production' &&
    process.env.AWS_AMPLIFY_COGNITO_ENDPOINT && {
      endpoint: process.env.AWS_AMPLIFY_COGNITO_ENDPOINT,
    }),
});
